import { NOTIFICATION_TYPE } from '../../../constants/common'
import { DEFAULT_TIME_ZONE } from '../../../constants/date'
import { createNowDateInUkTimezone } from '../../../utils/date'
import { Notification, NotificationInline } from '../../Notification'
import { Container } from '../Container'

import {
  NOTIFICATION_ERROR_TEXT,
  NOTIFICATION_INFO_TEXT,
  NOTIFICATION_INLINE_ACTIONS,
  NOTIFICATION_SUCCESS_TEXT,
  NOTIFICATION_WARNING_TEXT,
} from './Notifications.constants'

import * as styles from './Notifications.module.css'

function Notifications() {
  function handleClickTextButton() {
    window.alert('Clicked text button. Wow! Nice to see you.')
  }

  const creationDate = createNowDateInUkTimezone(DEFAULT_TIME_ZONE)

  return (
    <>
      <Container label='Notification, success'>
        <Notification
          isOpen
          className={styles.notification}
          title={NOTIFICATION_SUCCESS_TEXT}
          type={NOTIFICATION_TYPE.success}
        />
      </Container>
      <Container label='Notification, error'>
        <Notification
          isOpen
          className={styles.notification}
          title={NOTIFICATION_ERROR_TEXT}
          type={NOTIFICATION_TYPE.error}
        />
      </Container>
      <Container label='Notification, warning'>
        <Notification
          isOpen
          className={styles.notification}
          title={NOTIFICATION_WARNING_TEXT}
          type={NOTIFICATION_TYPE.warning}
        />
      </Container>
      <Container label='Notification, info'>
        <Notification
          isOpen
          className={styles.notification}
          title={NOTIFICATION_INFO_TEXT}
          type={NOTIFICATION_TYPE.info}
        />
      </Container>
      <Container label='Notification, success, with text, has close button'>
        <Notification
          withCloseButton
          className={styles.notification}
          text='Notification of changes were sent to tenants.'
          timeout={null}
          title={NOTIFICATION_SUCCESS_TEXT}
          type={NOTIFICATION_TYPE.success}
        />
      </Container>
      <Container label='Notification, success, with text, with text button, has close button'>
        <Notification
          withCloseButton
          className={styles.notification}
          text='Notification of changes were sent to tenants'
          textButtonValue='Text button'
          timeout={null}
          title={NOTIFICATION_SUCCESS_TEXT}
          type={NOTIFICATION_TYPE.success}
          onClickTextButton={handleClickTextButton}
        />
      </Container>
      <Container label='Notification, success, with text, with link, has close button'>
        <Notification
          withCloseButton
          className={styles.notification}
          linkProps={{ title: 'Link', to: '/' }}
          text='Notification of changes were sent to tenants'
          timeout={null}
          title={NOTIFICATION_SUCCESS_TEXT}
          type={NOTIFICATION_TYPE.success}
        />
      </Container>
      <Container label='Notification, success, with text, with checkbox, has close button'>
        <Notification
          checkbox
          withCloseButton
          checkboxProps={{
            label: 'Checkbox label',
          }}
          className={styles.notification}
          text='Notification of changes were sent to tenants'
          timeout={null}
          title={NOTIFICATION_SUCCESS_TEXT}
          type={NOTIFICATION_TYPE.success}
        />
      </Container>
      <Container label='Notification, success, with text, with creation time, has close button'>
        <Notification
          withCloseButton
          className={styles.notification}
          creationDate={creationDate}
          text='Notification of changes were sent to tenants'
          timeout={null}
          title={NOTIFICATION_SUCCESS_TEXT}
          type={NOTIFICATION_TYPE.success}
        />
      </Container>
      <Container label='Notification, success, with text, with read more button, has close button'>
        <Notification
          withCloseButton
          className={styles.notification}
          text='Notification of changes were sent to tenants. But its very looooooooooooooooooong.'
          timeout={null}
          title={NOTIFICATION_SUCCESS_TEXT}
          type={NOTIFICATION_TYPE.success}
        />
      </Container>
      <Container label='Notification, error, with text, has close button'>
        <Notification
          withCloseButton
          className={styles.notification}
          text='Excepteur sint occaecat cupidatat non proident.'
          timeout={null}
          title={NOTIFICATION_ERROR_TEXT}
          type={NOTIFICATION_TYPE.error}
        />
      </Container>
      <Container label='Notification, error, with text, with text button, has close button'>
        <Notification
          withCloseButton
          className={styles.notification}
          text='Notification of changes were sent to tenants'
          textButtonValue='Text button'
          timeout={null}
          title={NOTIFICATION_ERROR_TEXT}
          type={NOTIFICATION_TYPE.error}
          onClickTextButton={handleClickTextButton}
        />
      </Container>
      <Container label='Notification, error, with text, with link, has close button'>
        <Notification
          withCloseButton
          className={styles.notification}
          linkProps={{ title: 'Link', to: '/' }}
          text='Notification of changes were sent to tenants'
          timeout={null}
          title={NOTIFICATION_ERROR_TEXT}
          type={NOTIFICATION_TYPE.error}
        />
      </Container>
      <Container label='Notification, error, with text, with checkbox, has close button'>
        <Notification
          checkbox
          withCloseButton
          checkboxProps={{
            label: 'Checkbox label',
          }}
          className={styles.notification}
          text='Notification of changes were sent to tenants'
          timeout={null}
          title={NOTIFICATION_ERROR_TEXT}
          type={NOTIFICATION_TYPE.error}
        />
      </Container>
      <Container label='Notification, error, with text, with creation time, has close button'>
        <Notification
          withCloseButton
          className={styles.notification}
          creationDate={creationDate}
          text='Notification of changes were sent to tenants'
          timeout={null}
          title={NOTIFICATION_ERROR_TEXT}
          type={NOTIFICATION_TYPE.error}
        />
      </Container>
      <Container label='Notification, error, with text, with read more button, has close button'>
        <Notification
          withCloseButton
          className={styles.notification}
          text='Notification of changes were sent to tenants. But its very looooooooooooooooooong.'
          timeout={null}
          title={NOTIFICATION_ERROR_TEXT}
          type={NOTIFICATION_TYPE.error}
        />
      </Container>
      <Container label='Notification, warning, with text, has close button'>
        <Notification
          withCloseButton
          className={styles.notification}
          text='Excepteur sint occaecat cupidatat non proident.'
          timeout={null}
          title={NOTIFICATION_WARNING_TEXT}
          type={NOTIFICATION_TYPE.warning}
        />
      </Container>
      <Container label='Notification, warning, with text, with text button, has close button'>
        <Notification
          withCloseButton
          className={styles.notification}
          text='Notification of changes were sent to tenants'
          textButtonValue='Text button'
          timeout={null}
          title={NOTIFICATION_WARNING_TEXT}
          type={NOTIFICATION_TYPE.warning}
          onClickTextButton={handleClickTextButton}
        />
      </Container>
      <Container label='Notification, warning, with text, with link, has close button'>
        <Notification
          withCloseButton
          className={styles.notification}
          linkProps={{ title: 'Link', to: '/' }}
          text='Notification of changes were sent to tenants'
          timeout={null}
          title={NOTIFICATION_WARNING_TEXT}
          type={NOTIFICATION_TYPE.warning}
        />
      </Container>
      <Container label='Notification, warning, with text, with checkbox, has close button'>
        <Notification
          checkbox
          withCloseButton
          checkboxProps={{
            label: 'Checkbox label',
          }}
          className={styles.notification}
          text='Notification of changes were sent to tenants'
          timeout={null}
          title={NOTIFICATION_WARNING_TEXT}
          type={NOTIFICATION_TYPE.warning}
        />
      </Container>
      <Container label='Notification, warning, with text, with creation time, has close button'>
        <Notification
          withCloseButton
          className={styles.notification}
          creationDate={creationDate}
          text='Notification of changes were sent to tenants'
          timeout={null}
          title={NOTIFICATION_WARNING_TEXT}
          type={NOTIFICATION_TYPE.warning}
        />
      </Container>
      <Container label='Notification, warning, with text, with read more button, has close button'>
        <Notification
          withCloseButton
          className={styles.notification}
          text='Notification of changes were sent to tenants. But its very looooooooooooooooooong.'
          timeout={null}
          title={NOTIFICATION_WARNING_TEXT}
          type={NOTIFICATION_TYPE.warning}
        />
      </Container>
      <Container label='Notification, info, with text'>
        <Notification
          className={styles.notification}
          text='Excepteur sint occaecat cupidatat non proident.'
          timeout={null}
          title={NOTIFICATION_INFO_TEXT}
          type={NOTIFICATION_TYPE.info}
        />
      </Container>
      <Container label='Notification, info, with text, with text button, has close button'>
        <Notification
          withCloseButton
          className={styles.notification}
          text='Notification of changes were sent to tenants'
          textButtonValue='Text button'
          timeout={null}
          title='Info notification'
          type={NOTIFICATION_TYPE.info}
          onClickTextButton={handleClickTextButton}
        />
      </Container>
      <Container label='Notification, info, with text, with link, has close button'>
        <Notification
          withCloseButton
          className={styles.notification}
          linkProps={{ title: 'Link', to: '/' }}
          text='Notification of changes were sent to tenants'
          timeout={null}
          title='Info notification'
          type={NOTIFICATION_TYPE.info}
        />
      </Container>
      <Container label='Notification, info, with text, with checkbox, has close button'>
        <Notification
          checkbox
          withCloseButton
          checkboxProps={{
            label: 'Checkbox label',
          }}
          className={styles.notification}
          text='Notification of changes were sent to tenants'
          timeout={null}
          title='Info notification'
          type={NOTIFICATION_TYPE.info}
        />
      </Container>
      <Container label='Notification, info, with text, with creation time, has close button'>
        <Notification
          withCloseButton
          className={styles.notification}
          creationDate={creationDate}
          text='Notification of changes were sent to tenants'
          timeout={null}
          title='Info notification'
          type={NOTIFICATION_TYPE.info}
        />
      </Container>
      <Container label='Notification, info, with text, with read more button, has close button'>
        <Notification
          withCloseButton
          className={styles.notification}
          text='Notification of changes were sent to tenants. But its very looooooooooooooooooong.'
          timeout={null}
          title='Info notification'
          type={NOTIFICATION_TYPE.info}
        />
      </Container>
      <Container label='Notification, inline, success'>
        <NotificationInline
          text={NOTIFICATION_SUCCESS_TEXT}
          type={NOTIFICATION_TYPE.success}
        />
      </Container>
      <Container label='Notification, inline, success, with read more'>
        <NotificationInline
          text={NOTIFICATION_SUCCESS_TEXT.repeat(20)}
          type={NOTIFICATION_TYPE.success}
        />
      </Container>
      <Container label='Notification, inline, success, with actions'>
        <NotificationInline
          actions={NOTIFICATION_INLINE_ACTIONS}
          text={NOTIFICATION_SUCCESS_TEXT}
          type={NOTIFICATION_TYPE.success}
        />
      </Container>
      <Container label='Notification, inline, success, with link'>
        <NotificationInline
          linkProps={{ title: 'Link', to: '/' }}
          text={NOTIFICATION_SUCCESS_TEXT}
          type={NOTIFICATION_TYPE.success}
        />
      </Container>
      <Container label='Notification, inline, error'>
        <NotificationInline
          text={NOTIFICATION_ERROR_TEXT}
          type={NOTIFICATION_TYPE.error}
        />
      </Container>
      <Container label='Notification, inline, error, with read more'>
        <NotificationInline
          text={NOTIFICATION_ERROR_TEXT.repeat(20)}
          type={NOTIFICATION_TYPE.error}
        />
      </Container>
      <Container label='Notification, inline, error, with actions'>
        <NotificationInline
          actions={NOTIFICATION_INLINE_ACTIONS}
          text={NOTIFICATION_ERROR_TEXT}
          type={NOTIFICATION_TYPE.error}
        />
      </Container>
      <Container label='Notification, inline, error, with link'>
        <NotificationInline
          linkProps={{ title: 'Link', to: '/' }}
          text={NOTIFICATION_ERROR_TEXT}
          type={NOTIFICATION_TYPE.error}
        />
      </Container>
      <Container label='Notification, inline, warning'>
        <NotificationInline
          text={NOTIFICATION_WARNING_TEXT}
          type={NOTIFICATION_TYPE.warning}
        />
      </Container>
      <Container label='Notification, inline, warning, with read more'>
        <NotificationInline
          text={NOTIFICATION_WARNING_TEXT.repeat(20)}
          type={NOTIFICATION_TYPE.warning}
        />
      </Container>
      <Container label='Notification, inline, warning, with actions'>
        <NotificationInline
          actions={NOTIFICATION_INLINE_ACTIONS}
          text={NOTIFICATION_WARNING_TEXT}
          type={NOTIFICATION_TYPE.warning}
        />
      </Container>
      <Container label='Notification, inline, warning, with link'>
        <NotificationInline
          linkProps={{ title: 'Link', to: '/' }}
          text={NOTIFICATION_WARNING_TEXT}
          type={NOTIFICATION_TYPE.warning}
        />
      </Container>
      <Container label='Notification, inline, info'>
        <NotificationInline
          text={NOTIFICATION_INFO_TEXT}
          type={NOTIFICATION_TYPE.info}
        />
      </Container>
      <Container label='Notification, inline, info, with read more'>
        <NotificationInline
          text={NOTIFICATION_INFO_TEXT.repeat(20)}
          type={NOTIFICATION_TYPE.info}
        />
      </Container>
      <Container label='Notification, inline, info, with actions'>
        <NotificationInline
          actions={NOTIFICATION_INLINE_ACTIONS}
          text={NOTIFICATION_INFO_TEXT}
          type={NOTIFICATION_TYPE.info}
        />
      </Container>
      <Container label='Notification, inline, info, with link'>
        <NotificationInline
          linkProps={{ title: 'Link', to: '/' }}
          text={NOTIFICATION_INFO_TEXT}
          type={NOTIFICATION_TYPE.info}
        />
      </Container>
    </>
  )
}

export default Notifications
